import React, { FC } from 'react';
import { NavigationLinkFragment } from 'graphql/__generated__/types';
import useNavigationParams from 'hooks/useNavigationParams';
import SidebarLink from '../sidebar-link/sidebar-link';
import { isSidebarActiveLink } from 'utils/sidebar-navigation';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';

const SidebarExpandoLinks: FC<{ navigationLinks: NavigationLinkFragment[] }> = ({ navigationLinks }) => {
  const { currentPath } = useNavigationParams();

  return (
    <UitkSpacing padding={{ inlinestart: 'two' }}>
      <UitkLayoutFlex direction="column">
        {navigationLinks.map((navigationLink) => (
          <SidebarLink
            key={navigationLink.link.text}
            navigationLink={navigationLink}
            isActive={isSidebarActiveLink(navigationLink, currentPath)}
          />
        ))}
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default SidebarExpandoLinks;
